module.exports = __webpack_public_path__ + "static/media/bg-01@3x.3567e66b.png";